export function defineLabel(tag) {
    var label = {
        type: 'label',
        id: tag.id,
        fillBounds: tag.bbox,
        matrix: tag.matrix,
        tag: {
            hasText: true,
            initialText: '',
            html: true,
            readonly: true
        },
        records: tag.records,
        coords: null,
        static: true,
        require: null
    };
    return label;
}
